import styled from 'styled-components';

export const PostWrapper = styled.main`


  display: flex;
  justify-content: center;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${(props) =>
      !props.dark ? props.theme.colors.dark1 : props.theme.colors.white};
  }

  h1:not(:first-child),
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 1.5rem 0 0.5rem 0;
  }

  h1 {
    font-size: 2.25rem;
    line-height: 2.5rem;
    font-weight: 700;
  }

  h2 {
    font-size: 1.5rem;
    line-height: 1.875rem;
    font-weight: 600;
  }

  h3 {
    font-size: 1.250rem;
    line-height: 1.5rem;
    font-weight: 600;
  }

  h4 {
    font-size: 1.25rem;
    line-height: 1.5rem;
    font-weight: 400;
  }

  h5 {
    font-size: 1.125rem;
    line-height: 1.375rem;
    font-weight: 400;
  }

  h6 {
    font-size: 1rem;
    line-height: 1.125rem;
    font-weight: 700;
  }

  p {
    font-size: 1rem;
    line-height: 1.675rem;
    font-weight: 400;
    color: ${(props) =>
      !props.dark ? props.theme.colors.dark1 : props.theme.colors.dark3};
    font-family: '${(props) => props.theme.fonts.karla}';
  }

  a {
    text-decoration: none;
    position: relative;
    padding: 2px;
    color: ${(props) =>
      !props.dark ? props.theme.colors.dark1 : props.theme.colors.dark3};
    white-space: nowrap;
  }

  a::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    transform: translateY(calc(100% - 2px));
    width: 100%;
    height: 3px;
    background-color: ${(props) => props.theme.colors.blue};
    opacity: 0.3;
    transition: all 0.25s ease-out;
  }

  a:hover {
    color: ${(props) => props.theme.colors.blue};
  }

  a:hover::before {
    bottom: 18px;
    height: 100%;
    opacity: 0.2;
    transition: all 0.25s ease-out;
  }

  strong {
    font-weight: 700;
  }

  em {
    font-style: italic;
  }

  del {
    text-decoration: line-through;
  }

  pre {
    font-family: ${(props) => props.theme.fonts.code};
    font-size: 0.875rem;
    color: ${(props) => props.theme.colors.light1};
    background-color: ${(props) => props.theme.colors.dark3};
    padding: 2rem 2rem 1rem 2rem;
    line-height: 1.5rem;
    overflow-x: auto;
    margin: 1rem 0rem;
    span {
      color:'#fff'
    }
  }

  ul,
  ol {
    color: ${(props) =>
      !props.dark ? props.theme.colors.dark1 : props.theme.colors.dark3};
    margin: 1rem 0 1rem 2rem;
  }

  li {
    margin: 0.5rem 0;
    font-family: '${(props) => props.theme.fonts.karla}';
    line-height: 1.375rem;
  }

  .math-inline {
    font-size: 15px;
  }

  code {
    font-family: ${(props) => props.theme.fonts.code};
    font-size: 0.75rem;
    line-height: 1.875rem;
    background-color: ${(props) =>
      !props.dark ? '#c3e4f7' : props.theme.colors.dark4};
    padding: 0.1rem 0.5rem;
    border-radius: 0.25rem;
    margin: 0 0.3rem;
  }

  hr {
    border: 0;
    height: 1px;
    background-color: ${(props) =>
      !props.dark ? props.theme.colors.dark1 : props.theme.colors.blue};
    opacity: ${(props) => (!props.dark ? 0.1 : 0.5)};
    margin: 2rem 0;
  }

  table {
    width: 100%;
    border-spacing: 0.25rem;
    border-collapse: collapse;
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 400;
  }

  th {
    font-weight: 700;
  }

  table,
  th,
  td {
    border: 1px solid ${(props) => props.theme.colors.dark3};
  }

  th,
  td {
    text-align: left;
    padding: 0.5rem;
  }

  blockquote {
    background: ${(props) =>
      !props.dark ? props.theme.colors.lightBlue : props.theme.colors.dark4};
    border-left: 5px solid
      ${(props) => (!props.dark ? props.theme.colors.blue : '#1488c6')};
    margin: 1.5em 10px;
    padding: 0.5em 1rem;
    font-family: ${(props) => props.theme.fonts.karla};
  }

  img {
    margin: 1rem 0;
    max-width:100%;
    width:100%;
  }

  blockquote p {
    display: inline;
    line-height: 1.5rem;
    font-size: 1rem;
  }

  span {
    color: ${(props) =>
      !props.dark ? props.theme.colors.dark1 : props.theme.colors.dark3};
  }

  @media ${(props) => props.theme.breakpoints.mobile} {
    padding: 0;

    pre {
      padding: 1.75rem 0.75rem;
      white-space: pre-wrap; /* css-3 */
      white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
      white-space: -pre-wrap; /* Opera 4-6 */
      white-space: -o-pre-wrap; /* Opera 7 */
      word-wrap: break-word;
      .token .plain {
        white-space: pre-wrap; /* css-3 */
      white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
      white-space: -pre-wrap; /* Opera 4-6 */
      white-space: -o-pre-wrap; /* Opera 7 */
      word-wrap: break-word;
      }
    }
    blockquote {
      border-left: 2px solid ${(props) => props.theme.colors.blue};
    }
    code {
      padding: 0.1rem 0.3rem;
      margin: 0;
      white-space: -moz-pre-wrap; /* Mozilla */
  white-space: -hp-pre-wrap; /* HP printers */
  white-space: -o-pre-wrap; /* Opera 7 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: pre-wrap; /* CSS 2.1 */
  white-space: pre-line; /* CSS 3 (and 2.1 as well, actually) */
  word-wrap: break-word; /* IE */
  word-break: break-all;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      padding: 0.5rem 0;
      margin: 0.5rem 0;
    }

    ul,
    ol {
      margin: 1rem;
      line-height: 1.50rem;
    }

    h1 {
      font-size: 1.75rem;
      line-height: 2rem;
      font-weight: 700;
    }

    h2 {
      font-size: 1.25rem;
      line-height: 1.25rem;
      font-weight: 700;
    }

    h3 {
      font-size: 1.25rem;
      line-height: 1.25rem;
      font-weight: 600;
    }

    h4 {
      font-size: 1rem;
      line-height: 1.25rem;
      font-weight: 400;
    }

    h5 {
      font-size: 0.875rem;
      line-height: 1.25rem;
      font-weight: 400;
    }

    h6 {
      font-size: 0.75rem;
      line-height: 1.25rem;
      font-weight: 700;
    }

    p {
      font-size: 1rem;
      line-height: 1.5rem;
      font-weight: 400;
    }
    a {
      font-size: 1rem;
    }
  }
`;

export const InnerPostWrapper = styled.div`
  width: 80%;
  max-width: 1500px;
  background-color: ${(props) =>
    !props.dark ? props.theme.colors.white : props.theme.colors.dark};
  padding: ${(props) =>
    `${props.theme.spacings.xLarge} ${props.theme.spacings.xLarge}`};
  box-shadow: ${(props) =>
    !props.dark ? props.theme.shadows.shadow1 : props.theme.shadows.shadowDark};

  .author_name {
    color: ${(props) =>
      !props.dark ? props.theme.colors.dark1 : props.theme.colors.white};
  }

  @media ${(props) => props.theme.breakpoints.mobile} {
    width: 100%;
    padding: 0.5rem;
  }
`;

export const PostImageWrapper = styled.div`
  flex: 3;
  display: flex;
  flex-direction: column;
`;

export const HR = styled.hr`
  border: 1px solid ${(props) => props.theme.dark3};
`;
